Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rowDefaultProps = exports.rowPropTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _lineTypes = require('../constants/lineTypes');

var _lineTypes2 = _interopRequireDefault(_lineTypes);

var _adjustableSpacing = require('../constants/adjustableSpacing');

var _adjustableSpacing2 = _interopRequireDefault(_adjustableSpacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rowPropTypes = exports.rowPropTypes = {
  baseline: _lineTypes.lineTypePropType,
  topline: _lineTypes.lineTypePropType,

  top: _adjustableSpacing.adjustableSpacingShape,
  topMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  topLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  bottom: _adjustableSpacing.adjustableSpacingShape,
  bottomMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  bottomLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  vertical: _adjustableSpacing.adjustableSpacingShape,
  verticalMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  verticalLargeAndAbove: _adjustableSpacing.adjustableSpacingShape
};

var rowDefaultProps = exports.rowDefaultProps = {
  baseline: _lineTypes2['default'].NONE,
  topline: _lineTypes2['default'].NONE,

  top: null,
  topMediumAndAbove: null,
  topLargeAndAbove: null,
  bottom: null,
  bottomMediumAndAbove: null,
  bottomLargeAndAbove: null,
  vertical: _adjustableSpacing2['default'].NORMAL,
  verticalMediumAndAbove: null,
  verticalLargeAndAbove: null
};

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, rowPropTypes, {
  children: _propTypes2['default'].node
}));

var defaultProps = Object.assign({}, rowDefaultProps);

function getSpacingStyleName(spacingType, spacingValue) {
  return (String(spacingType) + '-' + String(spacingValue)).replace('.', '_');
}

function BaseRow(_ref) {
  var css = _ref.css,
      baseline = _ref.baseline,
      children = _ref.children,
      styles = _ref.styles,
      topline = _ref.topline,
      top = _ref.top,
      topMediumAndAbove = _ref.topMediumAndAbove,
      topLargeAndAbove = _ref.topLargeAndAbove,
      bottom = _ref.bottom,
      bottomMediumAndAbove = _ref.bottomMediumAndAbove,
      bottomLargeAndAbove = _ref.bottomLargeAndAbove,
      vertical = _ref.vertical,
      verticalMediumAndAbove = _ref.verticalMediumAndAbove,
      verticalLargeAndAbove = _ref.verticalLargeAndAbove;

  return _react2['default'].createElement(
    'div',
    css(baseline === _lineTypes2['default'].FULL && styles.baseline_full, baseline === _lineTypes2['default'].NONE && styles.baseline_none, topline === _lineTypes2['default'].FULL && styles.topline_full, vertical != null && styles[getSpacingStyleName('vertical', vertical)], verticalMediumAndAbove != null && styles[getSpacingStyleName('verticalMediumAndAbove', verticalMediumAndAbove)], verticalLargeAndAbove != null && styles[getSpacingStyleName('verticalLargeAndAbove', verticalLargeAndAbove)], top != null && styles[getSpacingStyleName('top', top)], topMediumAndAbove != null && styles[getSpacingStyleName('topMediumAndAbove', topMediumAndAbove)], topLargeAndAbove != null && styles[getSpacingStyleName('topLargeAndAbove', topLargeAndAbove)], bottom != null && styles[getSpacingStyleName('bottom', bottom)], bottomMediumAndAbove != null && styles[getSpacingStyleName('bottomMediumAndAbove', bottomMediumAndAbove)], bottomLargeAndAbove != null && styles[getSpacingStyleName('bottomLargeAndAbove', bottomLargeAndAbove)]),
    children
  );
}

BaseRow.componentCategory = 'Private';
BaseRow.displayName = 'BaseRow';
BaseRow.defaultProps = defaultProps;
BaseRow.propTypes = propTypes;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var color = _ref2.color,
      responsive = _ref2.responsive,
      unit = _ref2.unit;

  var responsiveUnits = [0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  var paddingStyles = {};

  responsiveUnits.forEach(function (size) {
    var sizeString = ('' + String(size)).replace('.', '_');
    paddingStyles['top-' + String(sizeString)] = {
      paddingTop: size * unit
    };
    paddingStyles['topMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
      paddingTop: size * unit
    });
    paddingStyles['topLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
      paddingTop: size * unit
    });
    paddingStyles['bottom-' + String(sizeString)] = {
      paddingBottom: size * unit
    };
    paddingStyles['bottomMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
      paddingBottom: size * unit
    });
    paddingStyles['bottomLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
      paddingBottom: size * unit
    });
    paddingStyles['vertical-' + String(sizeString)] = {
      paddingTop: size * unit,
      paddingBottom: size * unit
    };
    paddingStyles['verticalMediumAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.mediumAndAbove, {
      paddingTop: size * unit,
      paddingBottom: size * unit
    });
    paddingStyles['verticalLargeAndAbove-' + String(sizeString)] = _defineProperty({}, responsive.largeAndAbove, {
      paddingTop: size * unit,
      paddingBottom: size * unit
    });
  });

  return Object.assign({
    baseline_full: {
      borderBottom: '1px solid ' + String(color.divider)
    },

    baseline_none: {
      borderBottom: 0
    },

    topline_full: {
      borderTop: '1px solid ' + String(color.divider)
    }

  }, paddingStyles);
})(BaseRow);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/private/BaseRow.js
// module id = 151
// module chunks = 923280921217 19843951674672